'use client';
import Image from 'next/image';
import styles from './postCard.module.scss';
import { CiClock1, CiLocationOn, CiSaveUp1 } from 'react-icons/ci';
import { COLORS } from 'utilities';
import { Link, useInRouterContext } from 'react-router-dom';
import { CategoryFieldTypeEnum, PostType } from 'types';
import { PATH } from 'data';
import { TbCamera } from 'react-icons/tb';
import { TimeDifference, useBP } from 'scripts';
import AppLinkComp from 'components/appLink/appLink.index';
import NextLink from 'next/link';

const imageFormats = ['.png', '.jpg', '.jpeg', '.webp', '.svg'];

function PostCardComp({ data, isPanel }: { data: PostType<'list'>; isPanel?: boolean }) {
    const routerContext = useInRouterContext();
    const bp = useBP();
    const AdvanceLink: React.FC<React.PropsWithChildren<{ href: string }>> = (props) =>
        routerContext && isPanel ? (
            <Link to={props.href}>{props.children}</Link>
        ) : bp?.MD_LTE ? (
            <AppLinkComp href={props.href}>{props.children}</AppLinkComp>
        ) : (
            <NextLink href={props.href} target="__blank">
                {props.children}
            </NextLink>
        );

    const mainImage =
        data.main_image?.file ??
        data.gallery?.filter((i) => imageFormats.map((j) => i.file.toLowerCase().endsWith(j)).includes(true)).at(0)
            ?.file;
    const mainVideo = data.gallery
        ?.filter((i) =>
            ['.mp4', '.webm', '.ogg', '.avi', '.ogv', '.mkv', '.3gp', '.mpeg']
                .map((j) => i.file.toLowerCase().endsWith(j))
                .includes(true),
        )
        .at(0)?.file;

    return (
        <AdvanceLink href={isPanel ? PATH.panel.myAdsDetail(data.slug) : PATH.postDetail(data.slug)}>
            <div className={`${styles['post-card']} g-1 h-100`}>
                <div className={`${styles['info-layout']} flex-1 flex-column`}>
                    <p className="t-p1 t-500 t-l-black1 t-d-gray3">{data.title}</p>
                    <div className="flex-1">
                        {data.labeled_category_field_values?.map((item, index) => (
                            <p key={index} className="t-p2 t-400 t-l-black1 t-d-gray3">
                                {item.category_field.title}:{' '}
                                {item.option
                                    ? item.option.title
                                    : item.category_field.type === CategoryFieldTypeEnum.number
                                      ? item.value_number
                                      : item.value}{' '}
                                {item.category_field.unit ?? ''}
                            </p>
                        ))}
                    </div>
                    <span className="center-content-y mb-1">
                        <CiLocationOn size={14} color={COLORS.gray1} />
                        <p className="t-p3 t-300 t-gray1-i">
                            {data.locations
                                ?.map((i) => {
                                    const loc: string[] = [];
                                    if (i.parent) loc.push(i.parent.title);
                                    loc.push(i.title);
                                    return loc.join(' - ');
                                })
                                .join(', ')}
                        </p>
                    </span>
                    <div className="d-flex center-content-y g-3">
                        {data.is_renewed ? (
                            <span className="center-content-y">
                                <CiSaveUp1 size={14} color={COLORS.primary} />
                                <p className="t-p3 t-300 t-primary-i">نردبان شده</p>
                            </span>
                        ) : null}
                        <span className="center-content-y">
                            <CiClock1 size={14} color={COLORS.gray1} />
                            <p className="t-p3 t-300 t-gray1-i">{TimeDifference(data.renewed_at ?? data.created_at)}</p>
                        </span>
                    </div>
                </div>
                <div className={`flex-column justify-content-between g-2 ${styles['image-layout']}`}>
                    <div className={`${styles['image']}`}>
                        {mainImage?.length ? (
                            <Image src={mainImage} width={119} height={106} alt={data.title} />
                        ) : mainVideo?.length ? (
                            <video
                                src={mainVideo}
                                controls={false}
                                onContextMenu={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    return false;
                                }}
                            />
                        ) : (
                            <div className={`w-100 h-100 center-content bg-bgLight bg-d-bgDark ${styles['no-img']}`}>
                                <TbCamera size={32} className="t-l-gray1" />
                            </div>
                        )}
                    </div>
                    {/* <div className="center-content g-1">
                        <div className={`${styles['box']} center-content w-100`}>
                            <p className="t-l-gray1">{data.views_count} بازدید</p>
                        </div>
                        <div className={`${styles['box']} center-content w-100`}>
                            <p className="t-l-gray1">{data.likes_count} لایک</p>
                        </div>
                    </div> */}
                </div>
            </div>
        </AdvanceLink>
    );
}

export default PostCardComp;
